import { useLayoutEffect } from "react";
import { useDispatch } from "react-redux";
import { Navigate } from "react-router-dom";

import MainClient from "../Layouts/MainClient";
import { getLocalStorageState, loadState, _localGet } from "../localStorage";
import SessionExpiryRoute from "./SessionExpiryRoute";
import {
  setAllPermissions,
  setIsAuthenticated,
  setSession,
} from "../reducers/session";
const PrivateRoute = ({ children }) => {
  const dispatch = useDispatch();
  const data = _localGet("state") ? getLocalStorageState() : null;
  const isAuthenticated = data?.session?.isAuthenticated
    ? data.session.isAuthenticated
    : false;
  const token = data?.session?.session?.user_token ?? null;

  // updating session in redux
  const savedState = loadState();
  const initialState = savedState;
  useLayoutEffect(() => {
    if (token && isAuthenticated && initialState?.session) {
      if (initialState.session.isAuthenticated) {
        dispatch(setIsAuthenticated(true));
      }
      dispatch(
        setAllPermissions(
          initialState?.session?.session?.allPermissions
            ? initialState?.session?.session?.allPermissions
            : {},
        ),
      );
      dispatch(setSession(initialState.session.session));
    }
  }, [dispatch, initialState, isAuthenticated, token]);
  // updating session in redux

  if (data == null) {
    return <Navigate to="/login" />;
  }

  if (token && isAuthenticated) {
    return (
      <SessionExpiryRoute>
        <MainClient>{children}</MainClient>
      </SessionExpiryRoute>
    );
  } else {
    return <Navigate to="/login" />;
  }
};

export default PrivateRoute;
